const events = {
  analytics: {
    pageview: 'analytics:pageview',
    fire_page_view: 'analytics:fire_page_view',
  },
  download_btn: {
    initial_click: 'download_btn:initial_click',
    match_eezycore_free_dupe: 'download_btn:match_eezycore_free_dupe',
  },
  editor: {
    command: 'commandexec',
    exit: 'editor:exit',
    load: 'editor:load',
  },
  errors: {
    error404_page: 'errors:error404_page',
  },
  locale_prompt: {
    locale_prompt_accepted: 'locale_prompt:locale_prompt_accepted',
    locale_prompt_connects: 'locale_prompt:locale_prompt_connects',
    locale_prompt_dismissed: 'locale_prompt:locale_prompt_dismissed',
    switch_language: 'locale_prompt:switch_language',
  },
  generic: {
    track_generic_event: 'generic:track_event',
    ez_toggle_change: 'generic:ez_toggle_change',
  },
  modal: {
    close_modal: 'modal:close_modal',
  },
  search: {
    apply_filters: 'search:apply_filters',
    click: 'search:click',
    filter: 'search:filter',
    hide_show_search_filters: 'search:hide_show_search_filters',
    search_type: 'search:search_type',
    without_results: 'search:without_results',
    trending_search_click: 'search:trending_search_click',
    header_search_filter: 'search:header_search_filter',
    sponsored_click: 'search:sponsored_click',
  },
  sessions: {
    new_account_created: 'sessions:new_account_created',
  },
  show_page: {
    attribution_link_copied: 'show_page:attribution_link_copied',
    attribution_join_pro_click: 'show_page:attribution_join_pro_click',
    download_ad_modal: 'show_page:download_ad_modal',
    download_limit_modal_connects: 'show_page:download_limit_modal_connects',
    download_ad_modal_connects: 'show_page:download_ad_modal_connects',
    license_selector_free_modal_connects: 'show_page:license_selector_free_modal_connects',
    license_selector_free_modal_closes: 'show_page:license_selector_free_modal_closes',
    license_selector_free_modal_free_button: 'show_page:license_selector_free_modal_free_button',
    license_selector_free_modal_pro_button: 'show_page:license_selector_free_modal_pro_button',
    license_selector_free_modal_learn_more: 'show_page:license_selector_free_modal_learn_more',
    reveal_free_attribution_slidedown: 'show_page:reveal_free_attribution_slidedown',
    // start split-test: resource_show_modal_view
    modal: {
      build_resource_navigation_context: 'show_page:modal:build_resource_navigation_context',
      close_click: 'show_page:close_click',
      history_close_modal_view: 'show_page:modal:history_close_modal_view',
      next_arrow_click: 'show_page:modal:next_arrow_click',
      prev_arrow_click: 'show_page:modal:prev_arrow_click',
      reload_modal_view: 'show_page:modal:reload_modal_view',
      update_resource_navigation_context: 'show_page:modal:update_resource_navigation_context',
    },
    // end split-test: resource_show_modal_view
  },
  site_header: {
    explore_brusheezy: 'site_header:explore_brusheezy',
    explore_cats: 'site_header:explore_cats',
    explore_nav: 'site_header:explore_nav',
    explore_newest: 'site_header:explore_newest',
    explore_videezy: 'site_header:explore_videezy',
    header_join_pro: 'site_header:header_join_pro',
    header_login: 'site_header:header_login',
    header_signup: 'site_header:header_signup',
    related_tag_click: 'site_header:related_tag_click',
  },
  sponsored_search: {
    without_results: 'sponsored_search:without_results',
  },
  checkout: {
    error: 'checkout:error',
  },
  partner: {
    pagination_popup: 'partner:pagination_popup',
    results_click: 'partner:results_click',
    search_popup: 'partner:search_popup',
  },
};

export default events;
